import React from 'react'
import styles from 'components/pages/support/help/helpStyles'
import { HelpComponentProps } from 'types/Help'
import { useFormatMessage } from 'lib/localization'
import { isMyFeatureOn } from 'lib/splitio'
import { FEATURES } from 'lib/splitioFeatures'

const BASE_I18N_KEY = 'ess.help_self_service_4'

function SelfService4I18n({ classes, productName }: { classes: ReturnType<typeof styles>; productName?: string }) {
  const formatMessage = useFormatMessage(BASE_I18N_KEY)
  const formatValues = { productName }

  return (
    <div className={classes.content} data-testid="content">
      {formatMessage('office365_outbound', formatValues)}
      <p>{formatMessage('inbound_only', formatValues)}</p>
    </div>
  )
}

function SelfService4(props: HelpComponentProps) {
  const classes = styles()
  let isSmartlingEnabled = false
  try {
    isSmartlingEnabled = isMyFeatureOn(FEATURES.EGD_React_Smartling_Translations)
  } catch {
    // Default to OFF when called outside Redux context (e.g., renderToString for search)
  }

  // Flag ON: Use translated content
  if (isSmartlingEnabled) {
    return <SelfService4I18n classes={classes} productName={props.productName} />
  }

  // Flag OFF: Original hardcoded English content
  return (
    <div className={classes.content} data-testid="content">
      If you are using Microsoft Office 365 and want to route your outbound mail through {props.productName}, select
      that option. If you click the <b>Click here</b> link for instructions, Barracuda Campus will guide you through
      Office 365 configuration to work with {props.productName}.
      <p>
        If you only want to route your inbound mail through {props.productName} and NOT your outbound mail, select the
        2nd option on the page. You can change this routing later.
      </p>
    </div>
  )
}

export default SelfService4
